import { CapacityWebEntity } from "./capacity.web-entity"
import { ProductActivityHourWebEntity } from "./product-activity-hour.web-entity"


export interface ServiceHourWebEntity {
    forProductActivity: string
    day: number
    productActivityHours: ProductActivityHourWebEntity[]
    capacities: CapacityWebEntity[]
    isEnabled: boolean
    
  }